export default "__VITE_PUBLIC_ASSET__dff06af5__"